import React from 'react'
import Spot from "../../../Spot";
import VideoHelper from "../../Components/VideoHelper";
import { volumeCheckSpotStates } from "./volumeCheckSpotStates";
import { videoStates } from "../../../Spot/spotStateConstants";
import { isHighGradeBand } from "../../../../services/ThemingService";
import { connect } from 'react-redux';
import get from 'lodash.get';

const discoBall = require('../../../../../assets/studentPreChecks/DiscoBall.gif')
const bookVid = require('../../../../../assets/studentPreChecks/Book.mp4')
const multipleBooks = require('../../../../../assets/studentPreChecks/MulitpleBooks.gif')
const enabledMic = require('../../../../images/icons/enabledMic.svg')
const disabledMic = require('../../../../images/icons/iconMicOFF.svg')

/**
 * extend functionalities of the Spot component by composition
 */
function VolumeCheckSpot(props){

    const { state, isListening } = props

    if( state === volumeCheckSpotStates.discoBall ){
        return <VideoHelper videoSrc={discoBall} className="videoPlayerDiscoBall"/>
    }

    if( state === volumeCheckSpotStates.singleBook ){
        return <VideoHelper videoSrc={bookVid}/>
    }

    if( state === volumeCheckSpotStates.multipleBooks ){
        return <VideoHelper videoSrc={multipleBooks}/>
    }

    // For high grade band, show mic icon instead of Spot except for invisible state
    if (isHighGradeBand() && state !== videoStates.invisible) {
        // Use disabledMic when not listening, otherwise use enabledMic
        const micIcon = isListening ? enabledMic : disabledMic;
        return <img src={micIcon} alt="Microphone" className="volume-check-mic" />
    }

    // For all other grade bands or for invisible state, show Spot
    return <Spot spotState={state}/>
}

const mapStateToProps = state => {
  return {
    isListening: get(state, 'speech.listener.isListening', false),
  }
};

export default connect(mapStateToProps)(VolumeCheckSpot);